module.exports = __webpack_public_path__ + "static/media/6.13_preview.a047d953.png";